import BaseService from "@client.services/baseService";

export default class LogService extends BaseService {
  constructor() {
    super("log", true);
  }

  async log(message, data) {
    return super.post("", {
      message,
      data,
    });
  }
}
